import type { Subscription } from "@/types";
import { axiosPrivate } from "./axios";

interface AddOrganizationParams {
	email: string;
	contactEmail: string;
	afm: string;
	telNumber: string;
	softoneCode: string;
	address: string;
	organization: string;
	allowedCreditsNumber: number;
	dateRange: any;
	subscriptions: Subscription[];
	product: string;
	note: string;
	clientId: string;
	featureKeys: string[];
	notifyCustomer: boolean;
}

export const addOrganization = async (
	params: AddOrganizationParams,
	signal?: AbortSignal,
) => {
	const {
		email,
		contactEmail,
		telNumber,
		afm,
		softoneCode,
		address,
		organization,
		allowedCreditsNumber,
		subscriptions,
		dateRange,
		product,
		note,
		clientId,
		featureKeys,
		notifyCustomer,
	} = params;

	return await axiosPrivate.post(
		`/auth/orgs`,
		{
			email,
			contactEmail,
			telNumber,
			afm,
			softoneCode,
			address: address.trim(),
			organization: organization.trim(),
			allowedCreditsNumber,
			dateRange,
			product,
			subscriptions,
			note: note.trim(),
			clientId,
			feature_keys: featureKeys,
			notify_customer: notifyCustomer,
		},
		{
			headers: { "Content-Type": "application/json" },
			withCredentials: true,
			signal,
		},
	);
};

interface GetOrganizationSingleProductParams {
	org_id: string;
	product_id: string;
}

export const getOrganizationSingleProduct = async (
	_params: GetOrganizationSingleProductParams,
	signal?: AbortSignal,
) => {
	return await axiosPrivate.get(`/auth/orgs/`, {
		headers: { "Content-Type": "application/json" },
		withCredentials: true,
		signal,
	});
};
